import request from "@/utils/request";
import { generateQry } from "@/utils/helpers";

export function indexLabels(queryObj) {
  const query = generateQry(queryObj);

  return request({
    url: `api/admin/labels${query}`,
    method: "get"
  });
}

export function fetchLabel(id, locale) {
  return request({
    url: `api/admin/labels/${id}`,
    method: "get",
    headers: { "X-locale": locale }
  });
}

export function createLabel(data) {
  return request({
    url: `api/admin/labels`,
    method: "post",
    data
  });
}

export function updateLabel(id, data) {
  return request({
    url: `api/admin/labels/${id}`,
    method: "PUT",
    data
  });
}

export function deleteLabel(id) {
  return request({
    url: `api/admin/labels/${id}`,
    method: "delete"
  });
}
